import type {
  AiModelSettings,
  AiModelSettingsInput,
  AiModelTest,
  AiUsageReport,
  RoomAiSettings,
} from '@live-stream/shared'
import type { HttpClient } from '../http.js'

/** What AI costs: a room's settings and budget, and this month's usage. */
export class Ai {
  constructor(private readonly http: HttpClient) {}

  /** Hosts and cohosts: the room's AI switch, budget and retention, and how much is spent. */
  async room(slug: string): Promise<RoomAiSettings> {
    return (await this.http.get<{ ai: RoomAiSettings }>(`/ai/rooms/${slug}`)).ai
  }

  async roomUsage(slug: string): Promise<AiUsageReport> {
    return (await this.http.get<{ usage: AiUsageReport }>(`/ai/rooms/${slug}/usage`)).usage
  }

  /** The signed-in person's own videos' AI usage this month. */
  async myUsage(): Promise<AiUsageReport> {
    return (await this.http.get<{ usage: AiUsageReport }>('/ai/me/usage')).usage
  }

  /** Whether the signed-in person is an admin (may choose the editor's AI model). */
  async isAdmin(): Promise<boolean> {
    return (await this.http.get<{ admin: boolean }>('/admin/me')).admin
  }

  /** Admins: the video editor's AI model (never its key), and whether its price is known. */
  async editorModel(): Promise<{ settings: AiModelSettings; priceKnown: boolean }> {
    return this.http.get('/admin/ai')
  }

  async saveEditorModel(
    input: AiModelSettingsInput,
  ): Promise<{ settings: AiModelSettings; priceKnown: boolean }> {
    return this.http.put('/admin/ai', input)
  }

  /** Try settings with a short request before saving them (a key left out: the saved one). */
  async testEditorModel(input: AiModelSettingsInput): Promise<AiModelTest> {
    return this.http.post('/admin/ai/test', input)
  }
}
